import React from 'react';
import { Chart } from 'react-google-charts';
import WrapperCard from './WrapperCard';

const options = {
  legend: { position: 'bottom', alignment: 'start' },
  seriesType: 'bars',
  chartArea: {
    left: 45,
    right: 15,
    top: 10,
    bottom: 50,
  },
  series: {
    0: { color: '#00b4d8' },
    1: { color: '#0077b6' },
  },
  hAxis: {
    minorGridlines: { count: 1 },
  },
  vAxis: {
    format: 'short',
    logScale: true
  },
};

function CallTraffic({ isLoading, data }) {
  const buckets = data?.traffic_by_month|| [];
  
  const chartData = React.useMemo(() => {
    if (!buckets.length) {
      return [];
    }
    
    return buckets.reduce(
      (acc, curr) => {
        const key = curr.key_as_string;
        const outbound = curr.call_type.buckets[0]?.doc_count;
        const inbound = curr.call_type.buckets[1]?.doc_count;

        acc.push([{ v: key, f: key }, inbound, outbound]);
        return acc;
      },
      [['Date', 'Inbound', 'Outbound']],
    );
  }, [buckets]);

  return (
    <WrapperCard
      isLoading={isLoading}
      title="Call Traffic By Month"
      contentSkeletons={6}
      headerTooltip="6 month call traffic distributed by Month"
    >
      {
        chartData?.length ? (
          <Chart
          chartType="ComboChart"
          width="100%"
          height="249px"
          data={chartData}
          options={options}
        />
        ) : (
          <div style={{ textAlign: 'center', padding: '20px' }}>No data available</div>
        )
      }

    </WrapperCard>
  );
}

export default CallTraffic;
